<template>
  <CRow>
    <CModal
      :show.sync="modalError"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Erro de Integração"
      color="warning"
    >
      <div>
        <h4>{{ error.msg }}</h4>
        <p>{{ error.obs }}</p>
      </div>
      <div>
        <CButton color="warning" @click="modalError = false">Fechar</CButton>
      </div>
    </CModal>

    <CCol col="12 ">
      <CCard>
        <CCardBody>
          <h2>Consultas</h2>
          <CDataTable
            :items="errors"
            :fields="fields"
            column-filter
            hover
            sorter
            small
            :items-per-page="5"
            pagination
          >
            <template #acao="{ item }">
              <td v-if="item.codeerror == '31'">
                <CButton color="primary" variant="outline" square size="sm">
                  <router-link
                    class="router-link-ver"
                    :to="{
                      path: item.codeerror == '31' ? `/patient` : `/consultas`,
                      name: item.codeerror == '31' ? 'Pacientes' : 'Consultas',
                      query: {
                        id:
                          item.codeerror == '31'
                            ? item.idpatient
                            : item.identity,
                        type: 'b',
                        from: 'error',
                        page: 'integration',
                        idConsulta: item.idconsulta,
                        typeError: item.type,
                      },
                    }"
                    >VER</router-link
                  >
                </CButton>
              </td>
              <td>
                <CButton
                  style="margin-right: 1rem;"
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  @click="handleErro(item)"
                  v-if="item.codeerror != '31'"
                  >Ver</CButton
                >

                <CButton
                  color="danger"
                  variant="outline"
                  square
                  size="sm"
                  @click="DeleteErro(item)"
                  v-if="item.codeerror != '31'"
                  >Excluir</CButton
                >
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
export default {
  data() {
    return {
      modalError: false,
      typeErrorTiny: [
        { obs: "", code: 1, msg: "Token não informado" },
        { obs: "", code: 2, msg: "Token inválido ou não encontrado" },
        { obs: "", code: 3, msg: "XML mal formado ou com erros" },
        { obs: "", code: 4, msg: "Erro de procesamento de XML" },
        { obs: "", code: 5, msg: "API bloqueada ou sem acesso" },
        {
          obs: "",
          code: 6,
          msg:
            "API bloqueada momentaneamente - muitos acessos no último minuto",
        },
        { obs: "", code: 7, msg: "Espaço da empresa Esgotado" },
        { obs: "", code: 8, msg: "Empresa Bloqueada" },
        { obs: "", code: 9, msg: "Números de sequencia em duplicidade" },
        { obs: "", code: 10, msg: "Parametro não informado" },
        {
          obs: "",
          code: 11,
          msg: "API bloqueada momentaneamente - muitos acessos concorrentes",
        },
        { obs: "", code: 20, msg: "A Consulta não retornou registros" },
        { obs: "", code: 21, msg: "A Consulta retornou muitos registros" },
        {
          obs: "",
          code: 22,
          msg: "O xml tem mais registros que o permitido por lote de envio",
        },
        {
          obs: "",
          code: 23,
          msg: "A página que você está tentando obter não existe",
        },
        { obs: "", code: 30, msg: "Erro de Duplicidade de Registro" },
        { obs: "", code: 31, msg: "Erros de Validação" },
        { obs: "", code: 32, msg: "Registro não localizado" },
        { obs: "", code: 33, msg: "Registro localizado em duplicidade" },
        { obs: "", code: 34, msg: "Nota Fiscal não autorizada" },
        {
          obs: "",
          code: 35,
          msg: "Ocorreu um erro inesperado, tente novamente mais tarde",
        },
        { obs: "", code: 99, msg: "Sistema em manutenção" },
      ],

      error: "",
      errors: [],
      fields: [
        {
          key: "error",
          label: "Erro",
          _style: "max-width:40px;",
          filter: true,
        },
        {
          key: "data",
          label: "Data",
          _style: "max-width:40px;",
          filter: true,
        },
        {
          key: "hora",
          label: "Hora",
          _style: "max-width:40px;",
          filter: true,
        },
        {
          key: "namepatient",
          label: "Paciente",
          _style: "max-width:40px;",
          filter: true,
        },
        {
          key: "acao",
          label: "Ação",
          _style: "max-width:10px;",
          filter: true,
        },
      ],
    };
  },
  methods: {
    getDateIntgrationPatients() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}integration/consults`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((e) => {
            this.$http
              .get(
                `${process.env.VUE_APP_API_BASE_URL}consultas/${e.idconsulta}`
              )
              .then((res) => res.json())
              .then((res) => {
                
                e.data = res[0].date_at;
                e.hora = res[0].hour_at;
                this.errors.push(e);
              })
              .catch((error) => {
                
              });
          });
          
          //recupera consulta pelo id
        })
        .catch((error) => {
          
        });
    },
    perfil(item, index) {
      
      
    },
    handleErro(item) {
      
      this.error = this.typeErrorTiny.find((e) => e.code == item.codeerror);

      if ([1, 2, 5, 6, 11].includes(parseInt(item.codeerror))) {
        this.error.obs = "Entre em contato com o suporte";
        this.modalError = true;
      } else if ( [30,33].includes(parseInt(item.codeerror)) ) {
        this.error.obs =
          "Verifique no Tiny se o paciente ou a consulta já está cadastrado";
        this.modalError = true;
      } else if ([35,99].includes(parseInt(item.codeerror))) {
        this.error.obs =
          "tiny não está disponível no momento, tente novamente mais tarde";
        this.modalError = true;
      }
    },
    DeleteErro(item) {
      this.$http
        .delete(`${process.env.VUE_APP_API_BASE_URL}integration/consults`, {
          body: JSON.stringify(item),
        })
        .then((res) => res.json())
        .then((res) => {
          
          this.errors.forEach((e, index) => {
            if (e.id === item.id) {
              this.errors.splice(index, 1);
            }
          });

          
        })
        .catch((error) => {
          
        });
    },
  },

  mounted() {
    this.getDateIntgrationPatients();
  },
};
</script>
<style scoped></style>
